<!--
 * @Author: 主页面
 * @Date: 2021-05-13 10:03:58
 * @LastEditTime: 2021-05-13 10:10:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \参考\my-app\src\App.vue
-->
<template>
	<div  class="cy-button cy">
		<button class="btn-flow-light-one">
			流光光按钮1
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</button>
	</div>
</template>

<script>
export default {
	name: '流光按钮1',
}
</script>

<style  scoped>
	/* 引入对应样式 */
	@import url('./but-style/btn-flow-light-one.css');
</style>
